import styled, { keyframes } from 'styled-components/macro';

const makeSkeletonKeyframes = keyframes`
  100% {
    transform: translateX(100%);
  }
`;

export const Skeleton = styled.div`
  position: relative;
  background-image: linear-gradient(90deg, var(--skeleton-base) 0.58%, var(--skeleton-shine) 100%);
  border-radius: 3px;
  height: ${(props) => props.height};
  width: ${(props) => props.width};
  margin: ${(props) => props.margin || '5px'};
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    transform: translateX(-100%);
    background-image: linear-gradient(90deg, var(--skeleton-base) 0.58%, var(--skeleton-shine) 100%);
    animation: ${makeSkeletonKeyframes} 2200ms ease-in-out infinite;
  }
`;
